/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { Component } from "react";
import { connect } from "react-redux";
import Toast from "./sub_components/toast";
import * as authServices from "../services/authService";
import * as accountServices from "../services/accountService";
import * as eventService from "../services/eventService";
import * as utilService from "../services/utilService";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import LoginPopup from "./sub_components/loginpopup";
import {
  staticContentsImagePath as BASE_IMAGE_PATH,
  OPERATOR_ID,
} from "../configs/const";
import * as stringParser from "../util/string.util";
import * as dateUtil from "../util/date.util";
import { ReCAPTCHA_KEY } from "../configs/const";
import ReCAPTCHA from "react-google-recaptcha";
import Maintanence from "./sub_components/maintanence";
import * as constants from "../configs/const";
import UnderMaintenance from "./under_maintenance";
import { BRANDLOGOFILENAME } from "../configs/authSignupConfig";
import { showAdminBannerLink } from "../configs/casinoShowList";
import CaptchaComp from "./sub_components/captchaComp";
import { LBLTYPE, LoginWithDemo, PotanuCaptcha } from "../configs/casinoShowList";

let oid = OPERATOR_ID.toLowerCase();
const recaptchaRef = React.createRef();
const hostname = window && window.location && window.location.hostname;

class LoginSimple extends Component {
  constructor(props) {
    super(props);
    this.state = {
      uid: "",
      passcode: "",
      date: "",
      showToast: false,
      toastMsg: "",
      toastType: "",
      passVisible: false,
      showDownLoad: false,
      rememberMe: false,
      inMaitanence: false,
      inMaitanenceMessage: "",
      hasUmShow: true,
      recapchaVal: "",
      isDev: false,
      desktopBanners: {},
      mobileBanners: {},
      operatorDesktopBanners: {},
      operatorMobileBanners: {},
      clientWidth: document.documentElement.clientWidth,
      showPopup: false,
      requestId:null,
      captchaSolution:'',
      expiryCaptcha:0,
      demoButtonLoader: false,
    };
  }

  formatPickerDate(date) {
    var d = date,
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    year = year.toString().slice(-2);
    return [year, month, day].join("");
  }

  componentWillMount() {
    utilService.checkMaintainanceCall().then((res) => {
      if (res.isSuccess && !!res.items && res.items.isMaintenance) {
        this.setState({
          // inMaitanence: true,
          // inMaitanenceMessage: res.items,
        });
      }
    });
  }

  async componentDidMount() {
    localStorage.removeItem("homeData");
    localStorage.removeItem("userAuthDetail");
    localStorage.removeItem("tokenData");
    if (this.state.inMaitanence) {
      return false;
    }
    if (constants.isDev
    ) {
      this.setState({ isDev: true });
    }
    let savedData = localStorage.getItem("rememberData");
    if (!!savedData) {
      savedData = JSON.parse(savedData);
      if (!!savedData && !!savedData.uid) {
        this.setState({
          rememberMe: true,
          uid: savedData.uid,
          passcode: !!savedData.passcode ? savedData.passcode : "",
        });
      }
    }
    if (!window.location.href.includes("apk")) {
      this.setState({ showDownLoad: true });
      localStorage.setItem("appType", "web");
    } else {
      localStorage.setItem("appType", "mobile");
    }
    eventService.getBaseHomeData().then((res) => {
      let homeData = this.parseBook(res);
      localStorage.setItem("homeData", JSON.stringify(homeData));
      localStorage.setItem("isBaseData", "true");
    });

    // headers.append('Referrer-Policy', 'origin');
    // options.referrerPolicy = 'no-referrer-when-downgrade'; Referrer-Policy "origin"
    // headers.append('Accept', '*/*');
    // headers.append('Access-Encoding', 'gzip, deflate, br');
    // headers.append('Connection', 'keep-alive');
    var options = {};
    var headers = new Headers();
    headers.append("Content-Type", "application/json");
    // headers.append('Access-Control-Allow-Origin', '*');
    options.headers = headers;

    // let banners = await utilService.getBanner()
    // let banners = await utilService.getBannerListJson()
    // debugger
    if (showAdminBannerLink) {
      utilService.getOperatorBannerListJson().then((res) => {
        if (!!res) {
          let desktop_banners_arr = res.desktop;
          let mobile_banners_arr = res.mobile;

          let desktop_banners = {};
          for (var banner of desktop_banners_arr) {
            desktop_banners[
              banner.split(".")[0]
            ] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/desktop_banner_${banner}`;
          }

          let mobile_banners = {};
          for (var mobbanner of mobile_banners_arr) {
            mobile_banners[
              mobbanner.split(".")[0]
            ] = `${BASE_IMAGE_PATH}/${OPERATOR_ID.toLowerCase()}/banners/mobile_banner_${mobbanner}`;
          }

          this.setState(
            {
              operatorDesktopBanners: desktop_banners,
              operatorMobileBanners: mobile_banners,
            },
            () => {
              utilService.getBannerListJson().then((res) => {
                if (!!res) {
                  let desktop_banners_arr = res.desktop;
                  let mobile_banners_arr = res.mobile;

                  let desktop_banners = {};
                  for (var banner of desktop_banners_arr) {
                    desktop_banners[
                      banner.split(".")[0]
                    ] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`;
                  }
                  let mobile_banners = {};
                  for (var mobbanner of mobile_banners_arr) {
                    mobile_banners[
                      mobbanner.split(".")[0]
                    ] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`;
                  }

                  this.setState({
                    desktopBanners: desktop_banners,
                    mobileBanners: mobile_banners,
                  });
                }
              });
            }
          );
        }
      });
    } else {
      utilService.getBannerListJson().then((res) => {
        if (!!res) {
          let desktop_banners_arr = res.desktop;
          let mobile_banners_arr = res.mobile;

          let desktop_banners = {};
          for (var banner of desktop_banners_arr) {
            desktop_banners[
              banner.split(".")[0]
            ] = `${BASE_IMAGE_PATH}/banners/desktop_banner_${banner}`;
          }

          let mobile_banners = {};
          for (var mobbanner of mobile_banners_arr) {
            mobile_banners[
              mobbanner.split(".")[0]
            ] = `${BASE_IMAGE_PATH}/banners/mobile_banner_${mobbanner}`;
          }

          this.setState({
            desktopBanners: desktop_banners,
            mobileBanners: mobile_banners,
          });
        }
      });
    }

    // if (!!banners.items && banners.items.length > 0 && banners.isSuccess) {

    //     let desktop_banners_arr = banners.items.filter((banner) => { return banner.includes("desktop_banner") })
    //     let mobile_banners_arr = banners.items.filter((banner) => { return banner.includes("mobile_banner") })

    //     let desktop_banners = {}
    //     for (var banner of desktop_banners_arr) {
    //         desktop_banners[banner.split("_")[2].split(".")[0]] = banner
    //     }

    //     let mobile_banners = {}
    //     for (var mobbanner of mobile_banners_arr) {
    //         mobile_banners[mobbanner.split("_")[2].split(".")[0]] = mobbanner
    //     }

    //     this.setState({ desktopBanners: desktop_banners, mobileBanners: mobile_banners })
    // }
  }

  parseBook(data) {
    !!data &&
      data.length > 0 &&
      data.forEach((mkt, i) => {
        // let book = !!mkt.metadata && !!mkt.metadata.book ? stringParser.deSrlz("book|" + mkt.metadata.book) : {}
        let eventMeta = {};
        eventMeta.hasBookMaker =
          !!mkt.metadata &&
          !!mkt.metadata.hasBookMaker &&
          mkt.metadata.hasBookMaker === "True"
            ? "true"
            : "false";
        eventMeta.hasSession =
          !!mkt.metadata &&
          !!mkt.metadata.hasSession &&
          mkt.metadata.hasSession === "True"
            ? "true"
            : "false";
        eventMeta.hasTv =
          !!mkt.metadata &&
          !!mkt.metadata.hasTv &&
          mkt.metadata.hasTv === "True"
            ? "true"
            : "false";
        let book =
          !!mkt.metadata && !!mkt.metadata.book
            ? stringParser.deSrlz(mkt.metadata.book)
            : null;
        if (mkt.eventType.id === "300") {
          data[i].displayMarketNameTime = dateUtil.getBinaryMarketDisplayName(
            mkt.catalogue.marketName
          );
          data[i].symbolType =
            !!mkt.metadata && !!mkt.metadata.symbol_type
              ? mkt.metadata.symbol_type
              : null;
          data[i].eventId = mkt.event.id;
          data[i].eventName = mkt.event.name;
          data[i].competitionName = mkt.competition.name;
        }
        // const market_end_time = !!mkt.metadata && !!mkt.metadata.market_end_time ? mkt.metadata.market_end_time : null
        data[i].metadata = {};
        data[i].metadata.book = book;
        data[i].metadata.eventMeta = eventMeta;
        // if(!!market_end_time){
        //     data[i].metadata.market_time = moment(mkt.catalogue.marketTime).format('HH:mm')
        //     data[i].metadata.market_end_time = moment(new Date(parseInt(market_end_time)).toLocaleString()).format("HH:mm")
        // }
      });
    return data;
  }

  showPopup() {
    this.setState({ showPopup: true });
  }
  hidePopup() {
    this.setState({ showPopup: false });
  }

  loginSuccess() {
    this.setState({ showPopup: false });
    window.location.href = "/home";
  }

  setPassword() {
    this.setState({ showPopup: false });
    this.props.history.push("/setpassword");
  }

  notify(msg, type) {
    this.props.notify(msg, type);
  }

  showToast(msg, type) {
    let self = this;
    this.setState({ toastMsg: msg, toastType: type, showToast: true }, () => {
      setTimeout(() => {
        self.setState({ toastMsg: "", toastType: "", showToast: false });
      }, 3000);
    });
  }

  onChange(e) {
    const name = e.target.name;
    const value = e.target.value;
    this.setState({ [name]: value });
  }

  handleKey(e) {
    if (e.keyCode === 13) {
      this.signIn();
    }
  }

  // signIn() {
  //     let body = {
  //         "username": this.state.uid.trim().toLowerCase(),
  //         "password": this.state.passcode
  //     }
  //     if (!this.state.uid.trim()) {
  //         this.props.notify("Please Insert Username!", "error")
  //         return false
  //     }
  //     if (!this.state.passcode) {
  //         this.props.notify("Please Insert Password!", "error")
  //         return false
  //     }
  //     if (this.state.rememberMe) {
  //         let data = {
  //             "uid": this.state.uid.trim().toLowerCase(),
  //             "passcode": this.state.passcode
  //         }
  //         localStorage.setItem("rememberData", JSON.stringify(data))
  //     } else {
  //         localStorage.removeItem("rememberData")
  //     }
  //     authServices.signin(body).then(async (result) => {
  //         if (result.token) {
  //             let data = {
  //                 token: result.token
  //             }
  //             let accessControl = {
  //                 sports: true,
  //                 binary: true,
  //                 casino: true
  //             }
  //             localStorage.setItem("userAuthDetail", JSON.stringify(data))
  //             let velidateData = await authServices.velidateToken()

  //             if (!!velidateData.role && velidateData.role === "Client") {
  //                 localStorage.setItem("tokenData", JSON.stringify(velidateData))
  //                 localStorage.setItem("accessControl", JSON.stringify(accessControl))
  //                 let accData = await accountServices.getAccountData()
  //                 if(!!accData && !!accData.userLock && accData.userLock){
  //                     this.props.notify("User Is Locked. Please Contact Upperline!", "error")
  //                     this.logout()
  //                 }
  //                 localStorage.setItem("accountData", JSON.stringify(accData))
  //                 let configData = await authServices.getConfigButton()
  //                 localStorage.setItem("buttonsValues", JSON.stringify(configData))
  //                 if (velidateData.pwdch) {
  //                     this.props.history.push("/setpassword");
  //                 }
  //                 else {
  //                     // this.props.history.push("/home");
  //                     window.location.href = "/home"
  //                 }
  //             } else if (!!velidateData.role && velidateData.role !== "Client") {
  //                 this.props.notify(velidateData.role + " user is not allow to access this portal.", "error")
  //             } else {
  //                 this.props.notify(velidateData.exception.message, "error")
  //             }
  //         } else {
  //             this.props.notify(result.exception.message, "error")
  //         }
  //     })
  // }

  signIn(loginwithdemo = false) {
    const self = this;
    let body;
    if(!loginwithdemo){
    if (!this.state.uid.trim()) {
      this.props.notify("Please Insert Username!", "error");
      return false;
    }
    if (!this.state.passcode) {
      this.props.notify("Please Insert Password!", "error");
      return false;
    }
    if (this.state.rememberMe) {
      let data = {
        uid: this.state.uid.trim().toLowerCase(),
        passcode: this.state.passcode,
      };
      localStorage.setItem("rememberData", JSON.stringify(data));
    } else {
      localStorage.removeItem("rememberData");
    }
    body = {
      username: this.state.uid.trim().toLowerCase(),
      password: this.state.passcode.trim(),
    };
    if(PotanuCaptcha){
      if (!(!!this.state.captchaSolution)) {
        this.props.notify("Solve Captcha to move ahead", "error");
        return false;
      }
  
      if (this.state.expiryCaptcha < new Date().getTime()) {
        this.props.notify("Captcha is expired, Click Refresh.", "error");
        return false;
      }
      
      body['requestId'] = this.state.requestId;
      body['captchaAnswer'] = this.state.captchaSolution;
    }
  }
    this.setState({ buttonLoader: !loginwithdemo, demoButtonLoader: loginwithdemo }, () => {
      authServices.signin(body, loginwithdemo).then(async (result) => {
        // self.setState({buttonLoader: false});
        if (result.token) {
          let data = {
            token: result.token,
          };
          let accessControl = {
            sports: true,
            binary: true,
            casino: true,
          };
          localStorage.setItem("userAuthDetail", JSON.stringify(data));
          let velidateData = await authServices.velidateToken();

          if (!!velidateData.role && (velidateData.role === "Client"||velidateData.role === "DemoClient")) {
            localStorage.setItem("tokenData", JSON.stringify(velidateData));
            localStorage.setItem(
              "accessControl",
              JSON.stringify(accessControl)
            );
            let accData = await accountServices.getAccountData();
            if (!!accData && !!accData.userLock && accData.userLock) {
              this.props.notify(
                "User Is Locked. Please Contact Upperline!",
                "error"
              );
              this.props.logout();
            }
            localStorage.setItem("accountData", JSON.stringify(accData));
            let configData = await authServices.getConfigButton();
            localStorage.setItem("buttonsValues", JSON.stringify(configData));
            localStorage.removeItem('homeData');
            localStorage.removeItem('eventMenuDetails');
            if (velidateData.pwdch) {
              this.setPassword();
              self.setState({ buttonLoader: false, demoButtonLoader: false });
              this.setState({ setPassword: true }, () => {
                document.getElementById("setpwdoldpasscode").focus();
              });
            } else {
              let profData = await accountServices.getProfileData(this.state.uid);

              profData = JSON.stringify(profData)
              localStorage.setItem("profData", profData)
              // this.props.history.push("/home");
              self.setState({ buttonLoader: false, demoButtonLoader: false });
              this.loginSuccess();
            }
          } else if (!!velidateData.role && !["Client", "DemoClient"].includes(velidateData.role)) {
            this.props.notify(
              velidateData.role + " user is not allow to access this portal.",
              "error"
            );
          } else {
            this.props.notify(velidateData.exception.message, "error");
          }
        } else {
          self.setState({ buttonLoader: false, demoButtonLoader: false });
          this.props.notify(result.exception.message, "error");
        }
      });
    });
  }

  logout() {
    let appType = localStorage.getItem("appType");
    let rememberData = localStorage.getItem("rememberData");
    localStorage.clear();
    localStorage.setItem("rememberData", rememberData);
    if (appType === "mobile") {
      window.location.href = window.location.origin + "/apk";
    } else {
      window.location.href = window.location.origin + "/auth";
    }
  }

  // onPasswodVisible() {
  //     if (!!this.state.passVisible) {
  //         document.getElementById("passcode").type = "Password"
  //         document.getElementById("passcode-m").type = "Password"
  //     } else {
  //         document.getElementById("passcode").type = "text"
  //         document.getElementById("passcode-m").type = "text"
  //     }
  //     this.setState({ passVisible: !this.state.passVisible })
  // }
  onPasswodVisible(passid, name, value) {
    if (!!value) {
      document.getElementById(passid).type = "Password";
    } else {
      document.getElementById(passid).type = "text";
    }
    this.setState({ [name]: !value });
  }


  updateCaptchaData(requestId, solution, expiryCaptcha){
    this.setState({
      requestId: requestId,
      captchaSolution: solution,
      expiryCaptcha: expiryCaptcha
    });
  }

  render() {
    let settings = {
      dots: true,
      infinite: true,
      speed: 300,
      slidesToShow: 1,
      slidesToScroll: 1,
      autoplay: true,
      autoplaySpeed: 5000,
    };
    return (
      <>
        {!this.state.inMaitanence ? (
          <div className="loginbg">
            {/* <span className="tag-live" style={{ left: "0px", top: "0px", width: "100%", zIndex: "1", position: "fixed" }}>DEV</span> */}

            <div className="login">
              <div className="my-3">
                <div className="form-group">
                  <label htmlFor="email">User Name:</label>
                  <input
                    type="text"
                    tabIndex={1}
                    autoFocus
                    autoCapitalize="off"
                    autoCorrect="off"
                    spellCheck="false"
                    className="form-control"
                    placeholder="Enter User Name"
                    name="uid"
                    value={this.state.uid}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                  />
                  <span className="error d-none">Error</span>
                </div>
                <div className="form-group">
                  <label htmlFor="pwd">Password:</label>
                  <input
                    tabIndex={2}
                    type="Password"
                    className="form-control"
                    placeholder="Enter password"
                    name="passcode"
                    id="passcode"
                    value={this.state.passcode}
                    onKeyUp={(e) => {
                      this.handleKey(e);
                    }}
                    onChange={(e) => {
                      this.onChange(e);
                    }}
                  />
                  <span
                    onClick={() => {
                      this.onPasswodVisible(
                        "passcode",
                        "passVisible",
                        this.state.passVisible
                      );
                    }}
                    className="Passcode-visible"
                  >
                    {!!this.state.passVisible ? (
                      <i className="fa fa-eye" aria-hidden="true"></i>
                    ) : (
                      <i className="fa fa-eye-slash" aria-hidden="true"></i>
                    )}
                  </span>
                </div>
                {PotanuCaptcha &&
                  <CaptchaComp updateCaptchaData={(requestId, solution, expiryCaptcha)=>this.updateCaptchaData(requestId, solution, expiryCaptcha)} onKeyUp={(e)=>this.handleKey(e)}/>
                }
                <div>
                  <button
                    tabIndex={3}
                    type="button"
                    className="text-center login-bt"
                    onClick={() => {
                      this.signIn();
                    }}
                  >
                    LOGIN
                  </button>
                </div>
                {LoginWithDemo &&
                        <div className="">
                          <button
                            type="button"
                          className="text-center login-bt"
                            onClick={() => {
                              this.signIn(true)
                            }}
                          >
                            {this.state.demoButtonLoader && (
                              <svg className="spinner mr-2" viewBox="0 0 50 50">
                                <circle
                                  className="path"
                                  cx="25"
                                  cy="25"
                                  r="20"
                                  fill="none"
                                  strokeWidth="5"
                                ></circle>
                              </svg>
                            )}
                            <span className="">Demo ID</span>
                          </button>
                        </div>
                      }
              </div>
              {/* <ReCAPTCHA
                size={"invisible"}
                ref={recaptchaRef}
                sitekey={ReCAPTCHA_KEY}
              /> */}
            </div>
          </div>
        ) : (
          <UnderMaintenance
            inMaitanenceMessage={this.state.inMaitanenceMessage}
          />
        )}
        {/* <div className='under-maintance'>            
                    <img alt="Under Maintanence"  className="img-fluid" src={BASE_IMAGE_PATH + "/casino/banner/images/undermaintenance.png"} ></img>
                </div> */}
      </>
    );
  }
}

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {};
}
export default connect(mapStateToProps, mapDispatchToProps)(LoginSimple);
